import { useEffect } from 'react';
import { toast } from 'sonner';

type PushPayload = {
  title?: string;
  body?: string;
  url?: string;
  type?: string;
  campaignId?: string;
};

function currentCampaignIdFromLocation(): string | null {
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get('id');
  } catch {
    return null;
  }
}

/**
 * When the app is focused, the service worker posts push payloads instead of
 * showing an OS banner. Toast only if we are not already on that campaign
 * (live WebSocket toasts handle the in-campaign case).
 */
export function PushForegroundBridge() {
  useEffect(() => {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return undefined;
    const onMessage = (event: MessageEvent) => {
      const data = event.data;
      if (!data || data.type !== 'mythkit-push') return;
      const payload = (data.payload || {}) as PushPayload;
      const viewing = currentCampaignIdFromLocation();
      if (payload.campaignId && viewing && String(payload.campaignId) === String(viewing)) {
        return;
      }
      toast(payload.title || 'Myth-Kit', {
        description: payload.body || undefined,
      });
    };
    navigator.serviceWorker.addEventListener('message', onMessage);
    return () => navigator.serviceWorker.removeEventListener('message', onMessage);
  }, []);
  return null;
}
